var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtitleFrame"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.withSubtitles==true),expression:"withSubtitles==true"}],staticClass:"subtitleContainer"},[_c('div',{attrs:{"id":"subtitlesTag"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }